<template>
  <el-dialog title="合同预览" :visible.sync="localVisible" width="1000px" :modal-append-to-body="true" :lock-scroll="false"
    :close-on-click-modal="false" @close="close" append-to-body>
    <div class="content">
      <div class="content" v-for="page in pageAllNum" :key="page">
        <pdf :src="src" :page="page"></pdf>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button style="width: 116px" @click="close">取 消</el-button>
      <el-button type="success" style="width: 150px" @click="exportContract">导出</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { orderPushPdf } from '@/api/add'
import pdf from "vue-pdf-signature";
import CMapReaderFactory from "vue-pdf-signature/src/CMapReaderFactory.js";
import { viewContract } from '@/api/projectManage'
export default {
  name: "exportContract",
  components: {
    pdf,
  },
  data() {
    return {
      localVisible: this.visible,
      checked: false,
      pageAllNum: 30, // pdf文件总页数
      // pageNum: 1, // pdf文件页码
      src: "",
      pageNum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  watch: {
    visible(val) {
      this.localVisible = val;
    },
    localVisible(val) {
      this.$emit("update:visible", val);
    },
    contractInfo: {
      immediate: true,
      deep: true,
      handler: function(newVal) {
        console.log('contractInfo changed:', newVal);
        if (newVal) {
          this.$nextTick(() => {
            const blob = new Blob([newVal[0] ? newVal[0] : newVal], {
              type: "application/pdf;charset=utf-8",
            });
            let src = window.URL.createObjectURL(blob);
            this.getNumPages(src);
            this.src = pdf.createLoadingTask({
              url: src,
              CMapReaderFactory,
            });
            console.log('info的src', src);
          });
        }
      }
    },
    contractArray: function () {
      this.$nextTick(() => {
        if (this.contractArray && this.contractArray.length > 0) {
          const blob = new Blob([this.contractArray[0]], {
            type: "application/pdf;charset=utf-8",
          });
          let src = window.URL.createObjectURL(blob);
          this.getNumPages(src);
          this.src = pdf.createLoadingTask({
            url: src,
            CMapReaderFactory,
          });
          console.log('数组的src', src)
        }
      });
    },
  },
  props: ["visible", "contractInfo", "contractArray", "xmbh", 'dialogType'],
  methods: {
    // 获取PDF页数
    getNumPages(data) {
      let loadingTask = pdf.createLoadingTask(data);
      loadingTask.promise
        .then((pdf) => {
          this.pageAllNum = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    // 导出合同和协议
    async exportContract() {
      console.log(this.contractInfo)
      try {
        if (this.dialogType == 1) {
          //资源资产合同
          if (this.contractArray && this.contractArray.length > 0) {
            console.log('执行1')
            // 重新获取数据
            let res1 = await viewContract({ type: '0', xmbh: this.xmbh });
            let res2 = await viewContract({ type: '1', xmbh: this.xmbh });
            this.exportDone(res1, "集体经营性建设用地使用权出让合同");
            this.exportDone(res2, "出让监管协议");
          } else {
            console.log('执行2')
            // 重新获取数据
            let res = await viewContract({ type: '0', xmbh: this.xmbh });
            this.exportDone(res, '合同');
          }
        } else if (this.dialogType == 2) {
          //托管合同
          // console.log('执行的这里')
          this.exportDone(this.contractInfo, "农业生产托管服务合同");
        }
      } catch (error) {
        console.error('导出合同失败:', error);
        this.$message.error('导出合同失败，请重试');
      }
    },
    exportDone(data, name) {
      // 将数据转换为 base64
      // const reader = new FileReader();
      // reader.onload = () => {
      //   const base64 = reader.result;
      //   const fileName = name ? name + ".pdf" : this.xmbh + ".pdf";
      //   const downloadElement = document.createElement("a");
      //   downloadElement.href = base64;
      //   downloadElement.download = decodeURIComponent(fileName);
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click();
      //   document.body.removeChild(downloadElement);
      // };

      // // 创建 Blob 并读取为 base64
      // const blob = new Blob([data], {
      //   type: "application/pdf;charset=utf-8"
      // });
      // reader.readAsDataURL(blob);
      let blob = data;
      let binaryData = [];
      binaryData.push(blob);
      const fileName = name ? name + ".pdf" : this.xmbh + ".pdf";
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(
        new Blob(binaryData, { type: "application/pdf" })
      ); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = decodeURIComponent(fileName); //解码
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(href);
    },
    // pdf翻页
    // prePage() {
    // 	var page = this.pageNum
    // 	page = page > 1 ? page - 1 : this.pageTotalNum
    // 	this.pageNum = page
    // },
    // 下一页函数
    // nextPage() {
    // 	var page = this.pageNum
    // 	page = page < this.pageTotalNum ? page + 1 : 1
    // 	this.pageNum = page
    // },
    close() {
      this.localVisible = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="less" scoped>
.tools {
  display: flex;
  justify-content: center;
  align-content: center;
  gap: 10px;
}

/deep/.el-dialog {
  margin-top: 3vh !important;
}

/* .content {
  max-height: 560px;
  overflow: auto;
} */
.pdf-page {
  border: 1px solid #8b8383;
  margin-bottom: 10px;
}
</style>
<style lang="less" scoped>
.land-trust .el-table th {
  background: #0668b3;
  color: #fff;
}

.el-dialog {
  text-align: left;
}

.el-form-item {
  margin-bottom: 0px;
}

.pdfView {
  overflow: auto;
  height: 100%;
}

.content {
  width: 90%;
  min-width: 860px;
  margin: 10px auto;
  padding: 10px;
  background: rgba(85, 85, 85, 0.1);
  box-sizing: border-box;
  margin-top: 0;
}

/deep/.ht {
  margin-top: 10px !important;
  margin-bottom: 0 !important;
  box-sizing: border-box;
  height: calc(100% - 40px);
}

/deep/.el-dialog__body {
  height: calc(100% - 54px);
  padding-top: 0;
  overflow: auto;
  padding-bottom: 0;
  position: relative;

  .content {
    height: calc(100% - 128px);
  }
}

.pdf-page {
  border: 1px solid #8b8383;
  margin-bottom: 10px;
}
</style>
